import React, { useContext, useEffect, useState } from "react";
import { FooterHandler } from "./Footer/Footer";
import Navbar from 'react-bootstrap/Navbar';
import './nav_bar.css'
import { Button, Col, Row, Spin } from "antd";
import './landing.css'
import logo from "../assets/Logo/logosidetext.png"
import axios from "axios";
import { NavLink, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { EnvironmentContext } from "../routes/EnvironmentContext";
import useAuth from "../routes/useAuth";
import LandingPageNavbar from "./LandingPageNavbar";
import { PurchaseModal } from "./PurchaseModal";


export function Pricing() {
    const [loadingKey, setLoadingKey] = useState(false)
    const { locationData, isLocal } = useContext(EnvironmentContext)
    const { isFetching, isVerified } = useAuth()
    const [ openPurchaseModal, setOpenPurchaseModal ] = useState(false)
    const [selectedProduct, setSelectedProduct] = useState()
    const navigate = useNavigate()
    const userLocation = locationData

    useEffect(() => {
        // Checks if user is authenticated and sends them to billing of the protected route.
        // if fetch is ongoing always display loading screen.
        // if fetch is finished and user is not authenticated, continue showing the landing page.

    }, []) // runs once

    let oneOff
    let bronze
    let silver
    let subscription

    const price_data = [
        ...(userLocation?.timezone?.includes("Europe") && userLocation.country !== "GB"
            ? [
                oneOff = {
                    class: "oneOff",
                    title: "One Off Calculation",
                    price: "€24",
                    calculations: "1 Calculation",
                    math: `€24 per calculation`,
                    lookup_key: "1EU",
                },
                bronze = {
                    class: "bronze",
                    title: "Bronze",
                    price: "€180",
                    calculations: "100 Calculations",
                    math: `€${180 / 100} per calculation`,
                    lookup_key: "2EU",
                },
                silver = {
                    class: "silver",
                    title: "Silver",
                    price: "€230",
                    calculations: "200 Calculations",
                    math: `€${230 / 200} per calculation`,
                    lookup_key: "3EU",
                },
                // subscription = {
                //     class: "gold",
                //     title: "Gold",
                //     price: "€275",
                //     calculations: "Unlimited Calculations",
                //     math: "Billed Annually",
                //     lookup_key: "365EU",
                //     // extra: "/month",
                //     type: 'subscription'
                // }
            ]
            : userLocation?.country === "GB"
                ? [
                    oneOff = {
                        class: "oneOff",
                        title: "One Off Calculation",
                        price: "£20",
                        calculations: "1 Calculation",
                        math: `£20 per calculation`,
                        extra: "+VAT",
                        lookup_key: "1GBP",
                    },
                    bronze = {
                        class: "bronze",
                        title: "Bronze",
                        price: "£160",
                        calculations: "100 Calculations",
                        math: `£${160 / 100} per calculation`,
                        extra: "+VAT",
                        lookup_key: "2GBP",
                    },
                    silver = {
                        class: "silver",
                        title: "Silver",
                        price: "£200",
                        calculations: "200 Calculations",
                        math: `£${200 / 200} per calculation`,
                        extra: "+VAT",
                        lookup_key: "3GBP",
                    },
                    // subscription = {
                    //     class: "gold",
                    //     title: "Gold",
                    //     price: "£235",
                    //     calculations: "Unlimited Calculations",
                    //     math: "Billed Annually",
                    //     lookup_key: "365GBP",
                    //     extra: "+VAT",
                    //     type: 'subscription'
                    // }
                ]
                : [
                    oneOff = {
                        class: "oneOff",
                        title: "One Off Calculation",
                        price: "$26",
                        calculations: "1 Calculation",
                        math: `$26 per calculation `,
                        lookup_key: "1",
                    },
                    bronze = {
                        class: "bronze",
                        title: "Bronze",
                        price: "$199",
                        calculations: "100 Calculations",
                        math: `$${199 / 100} per calculation`,
                        lookup_key: "2",
                    },
                    silver = {
                        class: "silver",
                        title: "Silver",
                        price: "$250",
                        calculations: "200 Calculations",
                        math: `$${250 / 200} per calculation `,
                        lookup_key: "3",
                    },
                    // subscription = {
                    //     class: "gold",
                    //     title: "Gold",
                    //     price: "$299",
                    //     calculations: "Unlimited Calculations",
                    //     math: "Billed Annually",
                    //     lookup_key: "365",
                    //     // extra: "/month",
                    //     type: 'subscription'
                    // }
                ]
        )
    ];

    const handlePurchaseModal = (priceData) =>{
        setSelectedProduct(priceData)
        setOpenPurchaseModal(true)
    }

    return (
     
        isFetching ? (
            <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Spin size="large" />
            </div>
        ) : (
            isVerified ? (navigate('/home', { state: { defKey: 'billing' } })) : (
                <>
                    <LandingPageNavbar />
                    <Row
                        justify="center"
                        align="top"
                        style={{ paddingTop: "80px", paddingBottom: "128px" }}
                        className="background"
                    >
                        {/* Back Button */}
                        <Col span={24} style={{ position: 'absolute', top: '14vh', left: '1vw', zIndex: 10, }}>
                            <NavLink to="/welcome">
                                <Button type="text" icon={<ArrowLeftOutlined />} style={{ color: "white" }}>
                                    Back to Home
                                </Button>
                            </NavLink>
                        </Col>

                        {/* Heading Section */}
                        <Col span={24} style={{ textAlign: "center", color: "white", }}>
                            <h1 style={{ margin: 0 }}>Cut Through the Guesswork—Buy Credits That Matter.</h1>
                            <h6 style={{ marginTop: 12 }}>Choose a flexible plan and start running precise laser safety calculations instantly.</h6>
                        </Col>

                        {/* Pricing Cards */}
                        <Col span={24}>
                            <Row justify="center" gutter={[0, 32]}>
                                {price_data.map((priceData, index) => (
                                    <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={4} key={index}>
                                        <div className="pricing-card-wrapper">
                                            <div className="pricing-card">
                                                <div className={`title-row ${priceData.class}`}>
                                                    <h2 className="plan-title">{priceData.title}</h2>
                                                </div>
                                                <div className="content-box">
                                                    <div className="price">
                                                        <span className="amount">{priceData.price}</span>
                                                        <span className="period">{priceData?.extra}</span>
                                                    </div>
                                                    <ul className="features">
                                                        <li>{priceData?.calculations}</li>
                                                        <li style={{ color: "gray" }}>{priceData?.math}</li>
                                                    </ul>
                                                </div>
                                                <div className="button-wrapper">
                                                    {/* <a href="/register"> */}
                                                        <button className={`${priceData.class} priceButton`} block onClick={(()=>handlePurchaseModal(priceData))}>Buy now</button>
                                                    {/* </a> */}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                    <FooterHandler />
                    <PurchaseModal openPurchaseModal={openPurchaseModal} setOpenPurchaseModal={setOpenPurchaseModal} selectedProduct={selectedProduct}/>
                </>
            )
        )
    )

} 